<div #loading class="loading-wrapper">
  <div class="loading-content"></div>
</div>
<yw-alert [ngClass]="{ 'd-none': !showAlert }" (hiddenAlert)="hideToast()"></yw-alert>
<router-outlet></router-outlet>
